import React, { useEffect } from 'react'
import { FiAlertTriangle, FiArrowLeftCircle, FiSave, FiSlash } from 'react-icons/fi';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { clearListCatalogRegister, loadCatalogs, newProduct } from '../../app/store/products/thunk';
import { Loading } from '../../components/Loading';
import { useForm } from 'react-hook-form';
import { InputValidators } from '../../utils/InputValidators';

export const NewProduct = ({ navigateTo }) => {


    const dispatch = useDispatch();
    const { isLoading, listSuppliers, listBrands, listCategories, msg } = useSelector(state => state.products);
    const { register, handleSubmit, watch, reset, setValue, formState: { errors } } = useForm();
    const { usuario, id_emp } = useSelector(state => state.usuario);

    let user = id_emp;

    const descripcionCount = watch("descriptionProduct") || "";
    const typeProduct = watch("typeID");

    useEffect(() => {
        dispatch(loadCatalogs())
    }, []);

    const goBack = () => {
        dispatch(clearListCatalogRegister());
        navigateTo('list');
    }

    const save = (data) => {
        console.log(data);

        Swal.fire({
            title: 'Atención',
            text: `Está por registrar un Nuevo producto, ¿Desea de continuar con esta acción?`,
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true, // <-- ¡Este es importante!
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(newProduct(data, user));
                dispatch(loadCatalogs())
                reset();
            }
        })
    }

    const cancelRegister = () => {
        Swal.fire({
            title: 'Atención',
            text: `Está por cancelar el registro del producto, ¿Desea de continuar con esta acción?`,
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true, // <-- ¡Este es importante!
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
        }).then((result) => {
            if (result.isConfirmed) {
                reset();
                goBack();
            }
        })
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <form className='row' onSubmit={handleSubmit(save)}>
            <div className='col-12 mb-3'>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center  ">
                    <div className="d-flex mb-1">
                        <button className="btn btn-outline-dark border-0" onClick={goBack}>
                            <FiArrowLeftCircle size={23} />
                        </button>
                        <h1 className="h4 fw-bold mt-2"> | Nuevo Producto</h1>
                    </div>
                </div>
            </div>

            <div className='card'>
                <div className='card-body row'>
                    <div className='col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9'>
                        <div className='col-12 border-bottom mb-2'>
                            <h4 className=" mb-0 fw-bold text-dark mb-1">Detalles</h4>
                        </div>

                        {/* Fila 1 */}
                        <div className='row'>
                            <div className='col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
                                <div className="mb-3">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Tipo de producto:</label>
                                    <select className={`form-select ${errors.typeID ? 'is-invalid' : ''}`}  {...register("typeID", { required: 'Tipo, requerido' })}>
                                        <option value={1}>GENERAL</option>
                                        <option value={2}>MEMBRESIAS</option>
                                    </select>
                                    {
                                        errors.typeID &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.typeID.message}</small></span>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                <div className="mb-3">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Categoria:</label>
                                    <select className={`form-select ${errors.categoryID ? 'is-invalid' : ''}`}  {...register("categoryID", { required: 'Categoria, requerido' })}>
                                        <option value="" >Seleccione categoria</option>
                                        {
                                            listCategories.map((item, index) => (
                                                <option key={index} value={item.ID} className='text-uppercase' >{item.NAMECATEGORY}</option>
                                            ))
                                        }
                                    </select>
                                    {
                                        errors.categoryID &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.categoryID.message}</small></span>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                <div className="mb-3">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Marca:</label>
                                    <select className={`form-select ${errors.brandID ? 'is-invalid' : ''}`}  {...register("brandID", { required: 'Marca, requerido' })} >
                                        <option value="" >Seleccione marca</option>
                                        {
                                            listBrands.map((item, index) => (
                                                <option key={index} value={item.ID} className='text-uppercase' >{item.NAMEBRAND}</option>
                                            ))
                                        }
                                    </select>
                                    {
                                        errors.brandID &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.brandID.message}</small></span>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                <div className="mb-3">
                                    <label className="form-label"> <span className="text-danger fw-bold">*</span> Proveedor:</label>
                                    <select className={`form-select ${errors.supplierID ? 'is-invalid' : ''}`}  {...register("supplierID", { required: 'Proveedor, requerido' })} >
                                        <option value="" >Seleccione proveedor</option>
                                        {
                                            listSuppliers.map((item, index) => (
                                                <option key={index} value={item.ID} className='text-uppercase' >{item.NAMESUPPLIER}</option>
                                            ))
                                        }
                                    </select>
                                    {
                                        errors.supplierID &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.supplierID.message}</small></span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        {/* Fila 2 */}
                        <div className='row'>
                            <div className='col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
                                {typeProduct == 2 && (
                                    <div className="mb-3">
                                        <label className="form-label"><span className="text-danger fw-bold">*</span> Duración: </label>
                                        <input type="number" className={`form-control ${errors.durationProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateOnlyNumbers} autoComplete='off' {...register("durationProduct", { required: 'Duración, es requerido', })} />
                                        {
                                            errors.durationProduct &&
                                            <div className='text-left-5 mt-2'>
                                                <FiAlertTriangle size="20" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.durationProduct.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                )}
                            </div>

                            <div className='col-12 col-sm-12 col-md-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                <div className="mb-3">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Código de barra:</label>
                                    <input type="number" className={`form-control ${errors.barcode ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateOnlyNumbers} autoComplete='off' {...register("barcode", { required: 'Código de Barra, requerido' })} />
                                    {
                                        errors.barcode &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.barcode.message}</small></span>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                <div className="mb-3">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Nombre:</label>
                                    <input type="text" className={`form-control ${errors.nameProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateAlphanumeric} autoComplete='off' {...register("nameProduct", { required: 'Nombre, requerido' })} />
                                </div>
                                {
                                    errors.nameProduct &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="20" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.nameProduct.message}</small></span>
                                    </div>
                                }
                            </div>
                        </div>

                        {/* Fila 3 */}
                        <div className='row'>
                            <div className='col-12 col-sm-6 col-md-5 col-lg-5 col-xl-5 col-xxl-5'></div>

                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                <div className="mb-1">
                                    <label className="form-label">Descripcion <span className='small'>(250 Caracteres max)</span>:</label>
                                    <textarea rows="5" className={`form-control ${errors.descriptionProduct ? 'is-invalid' : ''}`} maxLength={250}
                                        {...register("descriptionProduct", {

                                            maxLength: { value: 250, message: 'La descripción de la mercancía no debe tener mas de 250 caracteres' }
                                        })}
                                        onKeyDown={InputValidators.validateAlphanumeric}
                                    ></textarea>
                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                        {
                                            errors.descriptionProduct ? (
                                                <div className="text-danger d-flex align-items-center">
                                                    <FiAlertTriangle size={18} className="me-1" />
                                                    <small className="fw-bold">{errors.descriptionProduct.message}</small>
                                                </div>
                                            ) : (<div></div>)
                                        }
                                        <small className="text-muted">{descripcionCount.length}/250</small>
                                    </div>
                                </div>

                                {typeProduct == 2 && (
                                    <div className="mb-3">
                                        <label className="form-label">Terminos y condiciones:</label>
                                        <textarea rows="5" className={`form-control ${errors.termsConditionsProduct ? 'is-invalid' : ''}`} {...register("termsConditionsProduct")} onKeyDown={InputValidators.validateAlphanumeric} ></textarea>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 '>
                        <div className='border-bottom'>
                            <h4 className=" mb-0 fw-bold text-dark mb-1">Precios y Costos</h4>
                        </div>

                        <div className='d-flex align-items-end'>
                            <div className="mt-2 me-3 flex-grow-1">
                                <label className="form-label"><span className="text-danger fw-bold">*</span> Costo HDL: </label>
                                <input type="text" className={`form-control ${errors.costProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateDecimalKeyDown} autoComplete='off' {...register("costProduct", { required: 'Costo HDL, es requerido', onBlur: (e) => InputValidators.formatDecimalOnBlur(e, "costProduct", setValue) },)} />
                                {
                                    errors.costProduct &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="20" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.costProduct.message}</small></span>
                                    </div>
                                }
                            </div>
                            <div className="mt-2">
                                <label className="form-label"><span className="text-danger fw-bold">*</span> Precio Venta: </label>
                                <input type="text" className={`form-control ${errors.priceProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateDecimalKeyDown} autoComplete='off' {...register("priceProduct", { required: 'Precio Venta, es requerido', onBlur: (e) => InputValidators.formatDecimalOnBlur(e, "priceProduct", setValue) },)} />
                                {
                                    errors.priceProduct &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="20" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.priceProduct.message}</small></span>
                                    </div>
                                }
                            </div>
                        </div>

                        <div className='border-bottom mt-3'>
                            <h4 className=" mb-0 fw-bold text-dark mb-1">Detalles de Existencia</h4>
                        </div>

                        <div className="row align-items-end mt-2">
                            <div className="col-12">
                                <label className="form-label"><span className="text-danger fw-bold">*</span> Ex. inicial:</label>
                                <input type="text" className={`form-control ${errors.currentStockProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateOnlyNumbers} autoComplete='off' {...register("currentStockProduct", { required: 'Existencia inicial, es requerido' },)} />
                                {
                                    errors.currentStockProduct &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="20" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.currentStockProduct.message}</small></span>
                                    </div>
                                }
                            </div>

                        </div>
                        <div className='d-flex align-items-end'>
                            <div className="mt-2 me-3 flex-grow-1">
                                <label className="form-label"><span className="text-danger fw-bold">*</span> Ex. Maxima: </label>
                                <input type="text" className={`form-control ${errors.maxStockProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateOnlyNumbers} autoComplete='off' {...register("maxStockProduct", { required: 'Existencia Max, es requerido', },)} />
                                {
                                    errors.maxStockProduct &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="20" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.maxStockProduct.message}</small></span>
                                    </div>
                                }
                            </div>
                            <div className="mt-2">
                                <label className="form-label"><span className="text-danger fw-bold">*</span> Ex. Minima: </label>
                                <input type="text" className={`form-control ${errors.minStockProduct ? 'is-invalid' : ''}`} onKeyDown={InputValidators.validateOnlyNumbers} autoComplete='off' {...register("minStockProduct", { required: 'Existencia Max, es requerido' },)} />
                                {
                                    errors.minStockProduct &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="20" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.minStockProduct.message}</small></span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                </div>
                <div className='card-footer text-end border-top'>
                    <button onClick={cancelRegister} type="button" className="btn btn-outline-danger me-2"  > <FiSlash size={22} /> Cancelar </button>
                    <button type="submit" className="btn btn-outline-primary"  > <FiSave size={22} /> Guardar </button>
                </div>
            </div>
        </form>


    )
}
